// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { contextPanelPlugin } from '@atlaskit/editor-plugin-context-panel';
export type {
	ContextPanelPlugin,
	ContextPanelPluginOptions,
	ApplyChangeHandler,
	HideObjectSidebar,
	HideObjectSidebarById,
	ShowObjectSidebar,
} from '@atlaskit/editor-plugin-context-panel';
